import { api, formatApiErrorDetail } from "./api";

export async function listAudits({ page = 1, pageSize = 20, mode, bounced } = {}) {
  try {
    const params = { page, page_size: pageSize };
    if (mode) params.mode = mode;
    if (bounced === true || bounced === false) params.bounced = bounced;
    const { data } = await api.get("/audits", { params });
    return { ok: true, data };
  } catch (e) {
    return { ok: false, message: formatApiErrorDetail(e.response?.data?.detail) };
  }
}

export async function getAudit(id) {
  try {
    const { data } = await api.get(`/audits/${id}`);
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      message: formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}
